export const ORDER = {
  get: "/orders",
  post: "/order",
  patch: "/order",
  singleOrder: "/order",
  checkout: "/checkout",
  orderTransactionStatus: "/payment-status",
};
